import { Injectable } from '@angular/core';

@Injectable()
export class PageConfig {
  static readonly paths = {
    landingPage: '',
    usan: {
      root: 'usan',
      app: ':app',
      new: ':app/new',
      edit: ':app/:id',
      forms: {
        base: 'forms',
        singleEntityDrugSalt: 'single-entity-drug-salt',
        singleEntity: 'single-entity',
        modifiedSalt: 'modified-salt',
        revisionToAdoptedUsan: 'revision-to-adopted-usan',
        contactLensMaterial: 'contact-lens-material',
        biologics: 'biologics'
      },
      applicant: 'applicant-dashboard',
      orgAdmin: 'orgadmin-dashboard',
      userDashboard: 'user-dashboard',
      usanAdmin: 'admin-dashboard',
      negotiator: 'negotiator-dashboard'
    },
    invalidPermissions: 'invalid-permissions',
    login: 'login',
    callback: 'oauth/callback'
  };
}
